import axios from "axios";
import { TAX, GET_STATE_URL, GET_COUNTY_URL, GET_CITY_URL, PRODUCTS_URL } from "../../../../../constants/config";

export function createTaxAuthority(payload) {
    return axios.post(
      `${TAX}/authority`, {...payload}
    );
  }

export function updateTaxAuthority(payload) {
    return axios.put(
        `${TAX}/authority/${payload.id}`, { ...payload }
    );
}

export function deleteTaxAuthority(id) {
    return axios.delete(
        `${TAX}/authority/${id}`
    );
}

export function getSingleTaxAuthorityRequest(id) {
    return axios.get(
        `${TAX}/authority/${id}`
    );
}

export function getTaxAuthorityList(params) {
    console.log("🚀 ~ getTaxAuthorityList ~ params:", params)
    return axios.get(
      `${TAX}/authority/list`, { params }
    );
  }


// Tax Attributes

export function createTaxAttribute(payload) {
  return axios.post(
    `${TAX}/attribute`, {...payload}
  );
}

export function updateTaxAttribute(payload) {
  return axios.put(
      `${TAX}/attribute/${payload.id}`, { ...payload }
  );
}

export function deleteTaxAttribute(id) {
  return axios.delete(
      `${TAX}/attribute/${id}`
  );
}

export function getSingleTaxAttributeRequest(id) {
  return axios.get(
      `${TAX}/attribute/${id}`
  );
}

export function getTaxAttributeList(params) {
  return axios.get(
    `${TAX}/attribute/list`, { params }
  );
}

export function getCompositeTaxValuesRequest(params) {
  return axios.get(
    `${PRODUCTS_URL}/tax/composite-data`, { params }
  );
}

// Tax Class

export function createTaxClass(payload) {
  return axios.post(
    `${TAX}/class`, {...payload}
  );
}

export function updateTaxClass(payload) {
  return axios.put(
      `${TAX}/class/${payload.id}`, { ...payload }
  );
}

export function deleteTaxClass(id) {
  return axios.delete(
      `${TAX}/class/${id}`
  );
}

export function getSingleTaxClassRequest(id) {
  return axios.get(
      `${TAX}/class/${id}`
  );
}

export function getTaxClassList(params) {
  return axios.get(
    `${TAX}/class/list`, { params }
  );
}

export function createTax(payload) {
  return axios.post(
    `${TAX}`, {...payload}
  );
}

export function updateTax(payload) {
  return axios.put(
    `${TAX}/${payload.id}`, { ...payload }
  );
}

export function getTaxListRequest(params) {
  return axios.get(
    `${TAX}/list`, { params } 
  );
}

export function getSingleTaxRequest(id) {
  return axios.get(
    `${TAX}/${id}`
);
}

export function getStates(params) {
  return axios.get(`${GET_STATE_URL}`, { params });
}

export function getCounty(params) {
  return axios.get(`${GET_COUNTY_URL}`, { params });
}

export function getCities(params) {
  return axios.get(`${GET_CITY_URL}`, { params });
}

export function listModeTax(params) {
  return axios.get(`${PRODUCTS_URL}/list/tax`, { params });
}

export function bulkTaxRequest(payload) {
  return axios.put(`${PRODUCTS_URL}/tax/bulk`, { ...payload });
}